<template>
    <div class="card-Job-skeleton">
      <div class="card-Job-skeleton__avatar card-Job-skeleton__avatar--pulse" />
      <div class="card-Job-skeleton__content">
        <div class="card-Job-skeleton__line card-Job-skeleton__line--title card-Job-skeleton__line--pulse" />
        <div class="card-Job-skeleton__line card-Job-skeleton__line--text card-Job-skeleton__line--pulse" />
        <div class="card-Job-skeleton__line card-Job-skeleton__line--text-short card-Job-skeleton__line--pulse" />
        
        <div class="card-Job-skeleton__footer">
          <div class="card-Job-skeleton__line card-Job-skeleton__line--small card-Job-skeleton__line--pulse" />
          <div class="card-Job-skeleton__line card-Job-skeleton__line--small card-Job-skeleton__line--pulse" />
        </div>
      </div>

      <div class="card-Job-skeleton__stats">
        <div class="card-Job-skeleton__line card-Job-skeleton__line--stat card-Job-skeleton__line--pulse" />
        <div class="card-Job-skeleton__counter">
          <div class="card-Job-skeleton__line card-Job-skeleton__line--stat card-Job-skeleton__line--pulse" />
          <div class="card-Job-skeleton__line card-Job-skeleton__line--stat card-Job-skeleton__line--pulse" />
        </div>
      </div>
    </div>
</template>
<style lang='scss' scoped>
@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.card-Job-skeleton {
  display: flex;
  padding: 16px;
  border: 1px solid #0000001A;
  border-radius: 12px;
  background: #fff;
  gap: 16px;
  position: relative;
  overflow: hidden;
  &__avatar--pulse,
  &__line--pulse {
    background: linear-gradient(90deg, #f0f0f0 25%, #f8f8f8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite linear;
  }

  &__avatar {
    flex-shrink: 0;
    @include vwUnit('width', 60, 48);
    @include vwUnit('height', 60, 48);
    border-radius: 50%;
  }

  &__content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__footer {
    display: flex;
    gap: 16px;
    margin-top: 8px;
  }

  &__stats {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    gap: 8px;
    padding-top: 4px;
  }

  &__counter {
    display: flex;
    gap: 8px;
  }
  &__line {
    height: 12px;
    width: 100%;
    border-radius: 4px;

    &--title {
      height: 20px;
      width: 85%;
      margin-bottom: 4px;
    }

    &--text-short {
      width: 70%;
    }

    &--small {
      height: 14px;
      width: 64px;
    }

    &--stat {
      height: 16px;
      width: 24px;
    }
  }
}
</style>
